import React from "react";

const SvgLegendGarage = ({ svgRef, title, ...props }) => (
  <svg viewBox="0 0 20 20" ref={svgRef} { ...{ ...{width: "1em", height: "1em"}, ...props } }>
    <title>{title}</title>
    <defs>
      <path
        id="LegendGarage_svg__a"
        d="M1041.958 370c-.758 0-1.48-.33-2.049-.953l-4.405-4.734c-.529-.587-1.295-.817-2.222-.673-2.333.447-4.61-.236-6.253-1.878a6.924 6.924 0 0 1-1.729-6.916l.287-.946 3.75 3.67c.427.451.997.7 1.604.7a2.19 2.19 0 0 0 1.604-.7l.025-.025c.451-.426.7-.996.7-1.603 0-.608-.249-1.178-.7-1.604l-.017-.017-3.653-3.734.946-.287a6.924 6.924 0 0 1 6.916 1.73c1.67 1.67 2.388 4.128 1.872 6.413l-.005.022c-.206.77-.01 1.397.615 1.97l4.806 4.477c.8.732 1.115 1.719.866 2.708-.276 1.097-1.2 2.02-2.296 2.296a2.705 2.705 0 0 1-.662.084"
      />
    </defs>
    <use
      fill="currentColor"
      xlinkHref="#LegendGarage_svg__a"
      transform="translate(-1025 -350)"
    />
  </svg>
);

const ForwardRef = React.forwardRef((props, ref) => (
  <SvgLegendGarage svgRef={ref} {...props} />
));
export default ForwardRef;



// WEBPACK FOOTER //
// ./src/common/icons/LegendGarage.js